import { Close, EmailOutlined } from "@mui/icons-material";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { ReactComponent as SendEmailIcon } from "assets/icons/SendEmail.svg";
import theme from "lib/theme";

interface NewLogisticsPickupRequestConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  mainContactEmail?: string;
}

const modalContainerSx = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "742px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  pt: 4.5,
  pb: 6,
  [theme.breakpoints.down("md")]: {
    px: 3,
  },
};

export default function NewLogisticsPickupRequestConfirmationModal({
  open,
  onClose,
  mainContactEmail,
}: NewLogisticsPickupRequestConfirmationModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="new-logistics-pickup-confirmation-title"
      aria-describedby="new-logistics-pickup-confirmation-description"
      sx={{ mx: 2 }}
    >
      <Box sx={modalContainerSx}>
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{ position: "absolute", top: 16, right: 16, color: "text.secondary" }}
        >
          <Close />
        </IconButton>

        <Box sx={{ textAlign: "center", pt: 1 }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              backgroundColor: "#FFF8E1",
              border: "2.5px solid #E5B860",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
            }}
          >
            <SendEmailIcon style={{ width: 36, height: 36, color: "#E0A744" }} />
          </Box>

          <Typography id="new-logistics-pickup-confirmation-title" mt={2.5} variant="h4" fontWeight={1000}>
            Thanks! We're reviewing your request
          </Typography>
          <Typography
            id="new-logistics-pickup-confirmation-description"
            mt={1.5}
            fontSize="18px"
            color="text.secondary"
            sx={{ maxWidth: 560, mx: "auto" }}
          >
            Our team will match a vendor for your preferred date and reach out by email with a confirmation. All you
            need to do in the meantime is make sure your address and submitted details are up to date.
          </Typography>

          <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                px: 2,
                py: 1,
                borderRadius: 999,
                border: `1px solid ${theme.palette.divider}`,
                backgroundColor: "#F8F9FA",
                display: "inline-flex",
                alignItems: "center",
                gap: 1.5,
                maxWidth: "100%",
              }}
            >
              <EmailOutlined sx={{ fontSize: 20, color: theme.palette.secondary.main, flexShrink: 0 }} />
              <Typography fontSize="16px" color="text.secondary" sx={{ textAlign: "left" }}>
                Next: we'll email{" "}
                <Box component="span" fontWeight={700} color="text.primary">
                  {mainContactEmail || "your main point of contact"}
                </Box>{" "}
                with your confirmation
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
